import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Pagination from "../../components/common/pagination/Pagination";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { faqListColumns } from "../../constant/tables-columns/tablesColums";
import { useNavigate } from "react-router";

export default function FaqList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [faqData, setFaqData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getCategory = async (params) => {
    const path = "admin/faq";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setFaqData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getCategory({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getCategory(allFilter);
  };

  const data = [];

  faqData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
    })
  );

  console.log(data);

  const navigate = useNavigate();

  const editCategory = (singleCategory) => {
    navigate("/edit-faq", { state: singleCategory });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست سوالات"} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={faqListColumns} rows={data} onEdit={editCategory} />
      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
